import React from 'react'
import styles from './AppStoreCancelDialog.scss'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import { centeredText } from 'lib/styleguide/base.scss'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

import img from './img.png'
import img2x from './img2x.png'
import img3x from './img3x.png'

export const APP_STORE_CANCEL_DIALOG = 'APP_STORE_CANCEL_DIALOG'

export class AppStoreCancelDialog extends React.PureComponent {
  render () {
    const { gotIt, onRequestClose } = this.props

    return (
      <ModalOverlay maxWidth='870px' onRequestClose={onRequestClose}>
        <div className={styles.appStoreCancelDialog}>
          <div className={styles.phoneImg}>
            <img src={img}
              srcSet={`${img} 1x, ${img2x} 2x, ${img3x} 3x`}
              alt='upgrade ios subscription'
              style={{ maxWidth: '90%' }} />
          </div>
          <div className={styles.instructions}>
            <div>
              <h2><T id='AppStoreCancelDialog.updateSubscription' defaultMessage='Update Subscription' /></h2>
              <ol style={{ paddingInlineStart: '30px' }}>
                <li>
                  <T
                    id='AppStoreCancelDialog.tapHome'
                    defaultMessage='Tap the <b>home button</b> to go to your list of apps.'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.goToSettings'
                    defaultMessage='Go to <b>Settings</b> icon. (Settings for your iPhone, looks like a gear icon)'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.tapItunes'
                    defaultMessage='Tap <b>iTunes & App Store</b>'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.tapAppleId'
                    defaultMessage='Tap your <b>Apple ID</b>. It’s the line that has your e-mail address in it.'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.whenPrompted'
                    defaultMessage='When prompted, select <b>View Apple ID</b>, you may have to enter the password for your Apple ID.'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.nowUnder'
                    defaultMessage='Now you are under the Account Settings page for your Apple ID.' />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.selectSubscriptions'
                    defaultMessage='Select <b>Subscriptions >.</b>'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.moreThanOne'
                    defaultMessage='If you have more than one subscription, select <b>Ride with GPS</b>.'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.tapCancel'
                    defaultMessage='Tap <b>Cancel Subscription</b>.'
                    values={{ b: (...c) => <b>{c}</b> }} />
                </li>
                <li>
                  <T
                    id='AppStoreCancelDialog.done'
                    defaultMessage='Done. Your subscription will not renew.' />
                </li>
              </ol>
              <CTA onClick={gotIt}><Msg m={commonCTAs.gotIt} /></CTA>
              <p className={centeredText}>
                <a onClick={onRequestClose}><Msg m={commonCTAs.cancel} /></a>
              </p>
            </div>
          </div>
        </div>
      </ModalOverlay>
    )
  }
}
